import { useQuery } from '@tanstack/react-query';
import { useSettings } from '../app/settings.js';
import { api } from './api.js';

export interface ContactInfo {
  phone: string;
  telegram: string;
  /** Joriy tildagi ish vaqti (bo'sh bo'lishi mumkin). */
  hours: string;
}

/**
 * Operator aloqa ma'lumoti (admin panel, Sozlamalar, `contact.*`).
 *
 * Bir kalit ostida keshlanadi: Profil, buyurtma va tovar sahifasi bitta so'rovni
 * baham ko'radi. Kech kelsa yoki xato bo'lsa bo'sh qiymat qaytadi — kartochka
 * shunchaki chizilmaydi, ekran kutmaydi.
 */
export function useContact(): ContactInfo {
  const { locale } = useSettings();
  const settings = useQuery({
    queryKey: ['public-settings'],
    queryFn: api.publicSettings,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  const data = settings.data;
  return {
    phone: data?.['contact.phone'] ?? '',
    telegram: data?.['contact.telegram'] ?? '',
    hours: (locale === 'RU' ? data?.['contact.hours_ru'] : data?.['contact.hours_uz']) ?? '',
  };
}
